var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppModal",
    {
      ref: "modal",
      attrs: { id: "editProductTitle", title: "Edit title" },
      on: { close: _vm.closeModalResetData, open: _vm.createDataBackup }
    },
    [
      _c("div", { staticClass: "form-group mb-4" }, [
        _c(
          "div",
          { staticClass: "position-relative" },
          [
            _c("AppInput", {
              class: { "form-error": _vm.$v.newTitleValue.$invalid },
              attrs: { placeholder: "", id: "title", maxlength: "50" },
              model: {
                value: _vm.newTitleValue,
                callback: function($$v) {
                  _vm.newTitleValue = $$v
                },
                expression: "newTitleValue"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "AppButton",
        {
          staticClass: "update-button w-100",
          attrs: {
            name: "update-title-button",
            disabled: _vm.$v.newTitleValue.$invalid
          },
          on: { click: _vm.updateTitleAndCloseModal }
        },
        [_vm._v("\n\t\tConfirm\n\t")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }